import type { Address } from '$types/address';
import { publicClient } from '$utils/publicClient';
import { AbiHub, AbiHubV2 } from '$lib/constants/abis';
import { zeroAddress } from 'viem';
import { config } from '$lib/constants/circlesV2Config';
import { users } from '$lib/states/users.svelte';

export const isV2Human = async (address: Address): Promise<boolean> => {
  const isHuman = await publicClient.readContract({
    address: config.v2HubAddress as Address,
    abi: AbiHubV2,
    functionName: 'isHuman',
    args: [address],
  });
  return isHuman as boolean;
};

export const isV1Human = async (address: string): Promise<boolean> => {
  const result = await publicClient.readContract({
    address: config.v1HubAddress as Address,
    abi: AbiHub,
    functionName: 'userToToken',
    args: [address],
  });
  return result !== zeroAddress;
};

export const isCirclesUser = async (address: Address): Promise<boolean> => {
  const profile = (await users.byAddress(address))?.current;
  return profile?.isCirclesUser || false;
};

export const isCirclesOrganizationV1 = async (address: Address): Promise<boolean> => {
  const result = await publicClient.readContract({
    address: config.v1HubAddress as Address,
    abi: AbiHub,
    functionName: 'organizations',
    args: [address],
  });
  return result === true;
};
